import withSpacing from '../../decorators/withSpacing/index';
import Link from './Link';
export default withSpacing(Link);
//# sourceMappingURL=index.js.map